import { Helmet } from "react-helmet-async";
import Hero from "../components/Hero";
import SearchBar from "../components/SearchBar";
import BookingBenefits from "../components/BookingBenefits";
import LimitedTimeOffer from "../components/LimitedTimeOffer";
import PopularDestinations from "../components/PopularDestinations";
import TopRatedHotels from "../components/TopRatedHotels";
import WhyBook from "../components/WhyBook";
// import HotelList from "../components/HotelList";
// import WhyChooseUs from "../components/WhyChooseUs";
// import BlogSection from "../components/BlogSection";
import Testimonials from "../components/Testimonials";
// import TrustedPartners from "../components/TrustedPartners";
import CTASection from "../components/CTASection";

import heroImg from "../assests/images/slider-1.webp";
import heroImg2 from "../assests/images/slider-2.webp";
import heroImg3 from "../assests/images/slider-3.webp";
import heroImg4 from "../assests/images/slider-4.webp";
import heroImg5 from "../assests/images/slider-5.webp";
import heroImg6 from "../assests/images/slider-6.webp";

// import {
//   Building2,
//   BadgeDollarSign,
//   Users,
//   Headphones,
// } from "lucide-react";

export default function Home() {
  return (
    <div>

      <Helmet>
        <title>Beach Hotels Dubai | Best Hotel Deals in Dubai</title>

        <meta
          name="description"
          content="Book cheap hotels, apartments, and resorts in Dubai. Compare prices and save up to 60% on your next stay with Beach Hotels Dubai."
        />

        <link rel="canonical" href="https://marinadubai.com/" />

        {/* Open Graph */}
        <meta property="og:title" content="Beach Hotels Dubai | Best Hotel Deals in Dubai" />
        <meta
          property="og:description"
          content="Book cheap hotels, apartments, and resorts in Dubai. Compare prices and save up to 60% on your next stay with Beach Hotels Dubai."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://marinadubai.com/" />
        <meta
          property="og:image"
          content="https://marinadubai.com/images/default-og.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Beach Hotels Dubai | Best Hotel Deals in Dubai" />
        <meta
          name="twitter:description"
          content="Book cheap hotels, apartments, and resorts in Dubai. Compare prices and save up to 60% on your next stay with Beach Hotels Dubai."
        />
        <meta
          name="twitter:image"
          content="https://marinadubai.com/images/default-og.png"
        />

        {/* SEO */}
        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* HERO */}
      <section className="relative">

        <Hero
          variant="home"
          title="Find the Best Hotel Deals in Dubai"
          subtitle="Save up to 60% on hotels, apartments and resorts across Dubai. Compare prices and book instantly."
          backgroundImages={[
            heroImg,
            heroImg2,
            heroImg3,
            heroImg4,
            heroImg5,
            heroImg6,
          ]}
          slideInterval={5000}
        >
          <SearchBar />
        </Hero>

      </section>



      {/* SECTIONS */}
      <BookingBenefits />
      <TopRatedHotels limit={4} />
      <PopularDestinations limit={6} showViewAllButton={true} />
      <LimitedTimeOffer />
      <WhyBook />
      <Testimonials />

      {/* <HotelList
        showSidebar={false}
        limit={3}
        showViewAllButton={true}
        showBanner={false}
        showHeading={true}
      /> */}
      {/* <WhyChooseUs /> */}
      {/* <BlogSection /> */}

      {/* <TrustedPartners /> */}
      <CTASection />

    </div>
  );
}